import { render, staticRenderFns } from "./InDialogAndMenu.vue?vue&type=template&id=436922c5&"
import script from "./InDialogAndMenu.vue?vue&type=script&lang=js&"
export * from "./InDialogAndMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports